"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a tab navigation
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A tab navigation
 */
function TabNav(props) {
  var extractedFields,
    tabAlignment,
    showTab = false;
  var getURLQuery = new URLSearchParams(props.params.pageQuery);
  var tabIndex = getURLQuery.get('tab');
  var TabContent = props => {
    var _props$scProps$render;
    var showSideColumn = ((_props$scProps$render = props.scProps.rendering.placeholders['tab-side-' + props.tabKey]) === null || _props$scProps$render === void 0 ? void 0 : _props$scProps$render.length) > 0;
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: showSideColumn ? 8 : 12
    }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: 'tab-main-' + props.tabKey,
      rendering: props.scProps.rendering,
      params: props.scProps.params
    })), showSideColumn && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 4
    }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: 'tab-side-' + props.tabKey,
      rendering: props.scProps.rendering,
      params: props.scProps.params
    })));
  };
  if (props.rendering.fields) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    tabAlignment = props.rendering.params.CenterAlign === '1' ? 'nav-tabs-center-align' : '';
    showTab = extractedFields.Tabs.length > 1;
  }
  if (showTab) {
    var titleDiv = (titleString, iconClass) => {
      return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(iconClass, " icon-lg col-12 mm-desktop-tablet-only")
      })), titleString);
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
      className: 'app-container ' + tabAlignment
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs, {
      defaultKey: tabIndex === null || tabIndex > extractedFields.Tabs.length - 1 || isNaN(tabIndex) ? '0' : tabIndex
    }, extractedFields.Tabs.map((tabList, key) => {
      return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs.Tab, {
        eventKey: key,
        title: titleDiv(tabList.fields.Title.value, tabList.fields.Icon.value)
      }, /*#__PURE__*/_react.default.createElement(TabContent, {
        scProps: props,
        tabKey: key
      }));
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource)
    }, /*#__PURE__*/_react.default.createElement(TabContent, {
      scProps: props,
      tabKey: "0"
    }));
  }
}
var _default = exports.default = TabNav;